import { client } from "../../../Infrastructure/agent";

export const MonthlySettingService = {
  loadHierarchy: () => client.get("/setting/LoadHierarchy"),
  saveHierarchy: (hierarchy) =>
    client.post("/setting/AddHierarchy", { hierarchy }),

  loadMonthlyDeckSettings: () =>
    client.get("/setting/LoadMonthlyProductionInputDeckSettings"),

  saveMonthlyDeckSettings: (setting, uploadedBy) =>
    client.post("/setting/SaveMonthlyProductionInputDeckSettings", {
      setting,
      uploadedBy,
    }),
};

